/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum CanvasTokenTypeObject {
  NONE = 0,
  STRING = 1,
  IMAGE = 2,
  PATH = 3,
  SHADER = 4,
  ASSET = 5,
}
